import { defineComponent as _defineComponent } from 'vue'
import { ref } from '../../../adapter-vue';
import {
  TUITranslateService,
} from '@tencentcloud/chat-uikit-engine';
import Icon from '../../common/Icon.vue';
import ForwardEachIcon from '../../../assets/icon/forward-each.svg';
import ForwardMergeIcon from '../../../assets/icon/forward-merge.svg';
import AddIcon from '../../../assets/icon/add-circle.svg';
import { isMobile } from '../../../utils/env';

interface IEmits {
  (key: 'oneByOneForwardMessage'): void;
  (key: 'mergeForwardMessage'): void;
  (key: 'toggleMultipleSelectMode'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["oneByOneForwardMessage", "mergeForwardMessage", "toggleMultipleSelectMode"],
  setup(__props, { emit: emits }: { emit: ({
  (key: 'oneByOneForwardMessage'): void;
  (key: 'mergeForwardMessage'): void;
  (key: 'toggleMultipleSelectMode'): void;
}), expose: any, slots: any, attrs: any }) {



const iconSize = ref(isMobile ? '25px' : '30px');

function oneByOneForwardMessage() {
  emits('oneByOneForwardMessage');
}

function mergeForwardMessage() {
  emits('mergeForwardMessage');
}

function cancelMultipleSelect() {
  emits('toggleMultipleSelectMode');
}

return { __sfc: true,emits, iconSize, oneByOneForwardMessage, mergeForwardMessage, cancelMultipleSelect, TUITranslateService, Icon, ForwardEachIcon, ForwardMergeIcon, AddIcon, isMobile }
}

})